import { useSearchParams } from "react-router-dom";

export enum SearchFilterMode {
  SEARCH = "search",
  FILTER = "filter",
}

export const useSearchFilterMode = (): SearchFilterMode => {
  const [params] = useSearchParams();
  const mode = params.get("mode");

  if (mode === SearchFilterMode.SEARCH) return SearchFilterMode.SEARCH;

  return SearchFilterMode.FILTER;
};
